// 接收
<template>
  <div class="upload">
    <el-upload
      :id="id"
      :class="(type==='file')?'upload-demo':((type==='headImg'&&page!=='usercenter')?'avatar-uploader':(hideUploadEdit===true)?'upload-demo hide':'upload-demo')"
      :action="this.baseUrl + 'file/upload/file'"
      :before-upload="beforeUpload"
      :accept="fileAcceptString"
      :on-preview="(type==='headImg')?blank:(type==='img'&&checkImg?handlePictureCardPreview:handlePreview)"
      :on-remove="(type==='headImg')?blank:handleRemove"
      :before-remove="(type==='headImg')?blank:beforeRemove"
      :limit="(type==='headImg')?0:limit"
      :on-exceed="(type==='headImg')?blank:handleExceed"
      :file-list="(type==='headImg')?[]:fileList"
      :multiple="(type==='file')"
      :data="(type==='file')?fileObj:imgObj"
      :on-success="(type==='file')?uploadFile:uploadImg"
      :on-error="uploadError"
      :show-file-list="(type==='headImg')?false:true"
      :list-type="(type==='img')?'picture-card':''"
      :on-change="(type==='img')?handleEditChange:blank">
      <el-button size="small" type="primary" v-if="type==='file'">点击上传</el-button>

      <div v-if="type==='headImg'">···</div>


      <div size="small" type="primary" v-if="type==='img'">
        <img style="width: 50%;vertical-align: middle;" src="../../assets/ic_list_add.png" alt />
      </div>


    </el-upload>

    <div class="footer"  v-if="type==='img'&&checkImg">
        <button class="submitBtn"  @click='submit'>提 交</button>
        <button  class="cancelBtn"  @click='cancel'>取 消</button>
    </div>



    <confirmModal :dialogState="state" @changeDialog="changeDialog" msg="是否确定删除"></confirmModal>
  </div>
</template>
<script>
import confirmModal from '../../components/basics/confirm-modal';

export default {
  props: {
    id: {
      type: String
    },
    type: {
      type: String
    },
    page: {
      type: String
    },
    fileAccept: {
      type: Array
    },
    limit: {
      type: Number,
      default: 10
    },
    sizeLimit: {
      type: Number,
      default: 30
    },
    fileObj: {
      type: Object,
      default: () => {
        return {
          token: ''
        }
      }
    },
    imgObj: {
      type: Object,
      default: () => {
        return {
          token: '',
          type: 'img'
        }
      }
    },
    imageUrl: {
      type: String,
      default: '../../assets/login_ic_agent.png'
    },
    cutImgNeed: {
      type: Boolean,
      default: false
    },
    fixedNumber: {
      type: Array,
      default: () => {
        return [1, 1]
      }
    },
    checkImg: {
      type: Boolean,
      default: false
    },
    showList: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      state: false,
      fileList: [],
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      hideUploadEdit: false,
      fileAcceptString: '',
      thisPageImg: '',
      btnArr: [
        {
          name: '确定',
          backMsg: 'confirm',
          style: 'main'
        },
        {
          name: '取消',
          backMsg: 'cancel',
          style: 'minor'
        }
      ],
      cutState: false,
      title: '提示',
      cutImg: '',
      cutImgName: '',
      testid: 0,
      returnData: {
        data: {
          fileId: 0
        }
      },
      checkedList: []
    };
  },
  created () {
    if (this.fileAccept) {
      for (var i = 0; i < this.fileAccept.length; i++) {
        if (i === 0) {
          this.fileAcceptString = this.fileAccept[i];
        } else {
          this.fileAcceptString =
            this.fileAcceptString + ',' + this.fileAccept[i];
        }
      }
    }
  },
  mounted () {
  },
  methods: {
    blank () {},
    // 友好提示框(删除时调用)
    changeDialog (e) {
      this.state = false;
      if (e === 'yes') {
        // 在此进行接口调用
      }
    },
    // 文件状态改变时的钩子
    handleEditChange (file, fileList) {
      this.hideUploadEdit = fileList.length >= this.limit;
    },
    // 文件列表移除文件时的钩子
    handleRemove (file, fileList) {
      this.hideUploadEdit = fileList.length >= this.limit;
      if (file && file.status === 'success') {
        this.$emit('deleteImg', file)
      }
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePreview (file) {
    },
    handlePictureCardPreview (file) {
      var fileId = file.response.data.fileId
      document.getElementsByClassName('el-upload-list el-upload-list--picture-card').forEach(e => {
        for (var i = 0; i < e.children.length; i++) {
          if (Number(e.children[i].getAttribute('index')) === fileId) {
            if (this.checkedList.findIndex(item => item.file.response.data.fileId === Number(e.children[i].getAttribute('index'))) !== -1) {
              e.children[i].children[2].style.display = 'none'
              this.checkedList.splice(this.checkedList.findIndex(item => item.file.response.data.fileId === Number(e.children[i].getAttribute('index'))), 1)
            } else {
              e.children[i].children[2].style.display = 'block'
              this.checkedList.push(
                {
                  file: file
                }
              )
            }
          }
        }
      })
    },
    // 文件超出个数限制时的钩子
    handleExceed (files, fileList) {
      this.$message.warning(
        '当前限制选择' +
          this.limit +
          `个文件，本次选择了 ${files.length} 个文件，共选择了 ${
            files.length + fileList.length
          } 个文件`
      )
    },
    // 上传文件之前的钩子
    beforeUpload (file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      var extension = false;
      var acceptString = ''
      this.cutImgName = file.name;
      if (this.fileAccept) {
        for (var i = 0; i < this.fileAccept.length; i++) {
          if (this.fileAccept[i] === testmsg) {
            extension = true;
          }
        }
      } else {
        extension = true;
      }
      const isLt2M = file.size / 1024 / 1024 < this.sizeLimit;
      if (!extension) {
        this.$message({
          message: '上传文件只能是' + this.fileAcceptString + '格式!',
          type: 'warning'
        });
      }
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 ' + this.sizeLimit + 'MB!',
          type: 'warning'
        });
      }

      if (this.cutImgNeed && extension && isLt2M) {
        this.cutImg = URL.createObjectURL(file);
        this.cutState = true;
      }

      return extension && isLt2M && !this.cutImgNeed;
    },
    // 删除文件之前的钩子
    beforeRemove (file, fileList) {
      if (file && file.status === 'success') {
        return this.$confirm(`确定移除 ${file.name}？`, '提示');
      }
    },
    // 文件上传成功时的钩子
    uploadImg (res, file) {
      document.getElementsByClassName('el-upload-list el-upload-list--picture-card').forEach(e => {
        for (var i = 0; i < e.children.length; i++) {
          if (i === e.children.length - 1) {
            e.children[i].setAttribute('index', file.response.data.fileId)
          }
        }
      })
      document.getElementsByClassName('el-upload-list__item-status-label').forEach(i => {
        i.style.display = 'none'
      })
      if (!this.cutImgNeed) {
        this.thisPageImg = URL.createObjectURL(file.raw);
        res.elementid = this.id;
        this.$emit('uploadImg', res)
      }
      this.$emit('acceptImg', file, this.cutImgName)
    },
    uploadFile (res, file) {
      this.$emit('uploadFile', res)
      if (!this.showList) {
        this.$('.el-upload-list').css('display', 'none')
      }
    },
    // 上传失败
    uploadError (file, fileList) {
      // console.log(err)
      this.$message({
        message: '对不起，上传失败，请重新上传！',
        type: 'warning'
      });
    },
    // 裁剪弹窗回调
    changeDataDialog (e) {
      if (e === 'confirm') {
        // 在此进行裁剪
        this.$refs.cut.finish();
      }
      this.cutState = false;
    },
    // 获取裁剪后图片URL
    getCutImgUrl (e) {
      this.thisPageImg = e.fileImg;
      this.testid = e.fileId;
      this.returnData.data.fileId = e.fileId;
      this.$emit('uploadImg', this.returnData);
    },
    // 提交多选选中参数
    submit () {
      this.$emit('checkImgList', 'submit', this.checkedList)
    },
    cancel () {
      this.$emit('checkImgList', 'cancel')
    }
  },
  watch: {
    // 监听imageUrl的改变
    imageUrl (oldVal, newVal) {
      this.thisPageImg = oldVal;
    }
  },
  computed: {},
  components: {
    confirmModal
  }
};
</script>
<style lang='scss'>
.footer{
  margin-top: 20px;
  text-align:center;
  padding-bottom:20px;
}
.submitBtn{
  // margin-right:10px;
}
.cancelBtn{
  // margin-left:10px;
}
.upload {
  max-height: 120px;
}
.avatar-uploader {
  width: 100%;
  height: 100%;
}
.avatar-uploader .el-upload {
  border: 1px dashed $greyd9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
}
.avatar-uploader .el-upload:hover {
  border-color: $blue;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: $greyd9;
  width: 100%;
  height: 100%;
  text-align: center;
  margin-top: calc(50% - 14px);
}
.avatar {
  width: 100%;
  height: 100%;
  display: block;
}
.uploadFaceImg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: none;
}
.uploadFaceImg img {
  width: 100%;
  height: 100%;
}
.el-upload:hover .uploadFaceImg {
  display: block;
}

.hide .el-upload--picture-card {
  display: none;
}
</style>
